
import {whenReady} from './Util';

import {
	isEmptyInput,
	isValidUsernameInput,
	isValidPasswordInput
} from './Validation';

class LoginForm {

	constructor( formEl ) {
		this.formEl = formEl;

		this.userInputEl = this.formEl.querySelector( 'input[name=lgn_usr]' );
		this.passInputEl = this.formEl.querySelector( 'input[name=lgn_pwd]' );

		this.userErrorEl = this.formEl.querySelector( '.emailerror' );
		this.passErrorEl = this.formEl.querySelector( '.pwderror' );

		// Validations.
		this.formEl.addEventListener( 'focusout', ( ev ) => {
			if ( ev.target.matches( 'input[name=lgn_usr]' ) ) {
				this.validateUsernameInput()
			}
			if ( ev.target.matches( 'input[name=lgn_pwd]' ) )  {
				this.validatePasswordInput()
			}
		} )

		// Text-Trimming.
		this.formEl.addEventListener( 'input', ( ev ) => {
			if ( ev.target.matches( 'input[name=lgn_usr]' ) ) {
				this.trimUserInputValue()
			}
			if ( ev.target.matches( 'input[name=lgn_pwd]' ) )  {
				this.trimPassInputValue()
			}
		} )

		// Validate once more on submit, so we don't submit empty values.
		this.formEl.addEventListener( 'submit', ( ev ) => this.onSubmit( ev ) );

		// Copy Action to all other Login Forms, if they don't have an action.
		const action = this.formEl.action;
		if ( action ) {
			const newAction = action.substring( 0, action.indexOf( '?' ) ) + '?';
			const loginEls = document.querySelectorAll( '.acl_account_login' );
			loginEls.forEach( loginEl => {
				loginEl.setAttribute( 'action', newAction );
			} );
		}
	}

	onSubmit = ( evt ) => {
		let isValid = true;

		if ( isEmptyInput( this.userInputEl ) ) {
			this.toggleErrorMessage( this.userErrorEl, true );
			isValid = false;
		}

		if ( isEmptyInput( this.passInputEl ) ) {
			this.toggleErrorMessage( this.passErrorEl, true );
			isValid = false;
		}

		// Cancel submit, if not valid.
		if ( ! isValid ) {
			evt.preventDefault();
		}

		// Return false cancels submit.
		return isValid;
	};

	validateUsernameInput = () => {
		const isValid = isValidUsernameInput( this.userInputEl );
		this.toggleErrorMessage( this.userErrorEl, !isValid );
	};

	validatePasswordInput = () => {
		const isValid = isValidPasswordInput( this.passInputEl );
		this.toggleErrorMessage( this.passErrorEl, !isValid );
	};

	trimUserInputValue = () => {
		// Trim Whitespaces from E-Mail Field.
		this.userInputEl.value = this.userInputEl.value.trimEnd();
	};

	trimPassInputValue = () => {
		// Trim Whitespace from End of Password Input.
		// this.passInputEl.value = this.passInputEl.value.trimEnd();
	};

	toggleErrorMessage = ( errorEl, showError ) => {
		errorEl.classList.toggle( 'row_has_message', showError );
	};

	static initForm = ( formEl ) => {
		formEl.ACL_LOGIN_FORM ??= new LoginForm( formEl );
		return formEl.ACL_LOGIN_FORM;
	}
}


// Load POS Login via AJAX.
whenReady.then( () => {

	// Always initiate all Loginforms, even if the AJAX Call fails.
	const loginFormEls = document.querySelectorAll( '.acl_account_login.account_login' );
	loginFormEls.forEach( ( formEl ) => {
		LoginForm.initForm( formEl );
	} );
} );

export default LoginForm;
